import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'

import DestinationsCarousel from './DestinationsCarousel'
import { fetchPopularDestinations } from 'actions/DestinationAlertsActions'

interface Props {
  currentRegionName: string;
  popularDestinations: {
    domestic: App.PopularDestinationState;
    international: App.PopularDestinationState;
  };
}

function DestinationCarousels({ popularDestinations, currentRegionName }: Props) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchPopularDestinations('domestic'))
    dispatch(fetchPopularDestinations('international'))
  }, [dispatch])

  if (!popularDestinations.domestic.destinations?.length && !popularDestinations.international.destinations?.length) {
    return null
  }

  return (
    <>
      {!!popularDestinations.domestic.destinations?.length &&
        <DestinationsCarousel
          heading={`Popular hotel destinations in ${currentRegionName}`}
          destinations={popularDestinations.domestic.destinations}
        />
      }
      {!!popularDestinations.international.destinations?.length &&
        <DestinationsCarousel
          heading="Popular hotel destinations internationally"
          destinations={popularDestinations.international.destinations}
        />
      }
    </>
  )
}

function mapStateToProps(state: App.State) {
  return ({
    popularDestinations: state.destination.popularDestinations,
    currentRegionName: state.geo.currentRegionName,
  })
}

export default connect(mapStateToProps)(DestinationCarousels)
